module.exports = __webpack_public_path__ + "img/5888f24.jpg";